var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"mt-1",attrs:{"value":_vm.showAlert,"type":_vm.type}},[_vm._t("content",function(){return [_vm._v(" "+_vm._s(_vm.displayText)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }